exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3ce625b6] .adp-dd-options {\n  max-width: 310px;\n  right: 20px;\n}\n", ""]);

// exports
